import React from "react";
import Youtube from "assets/youtube.svg";
//import Copy from "assets/copy.svg";
import Instagram from "assets/instagram.svg";
import Twitter from "assets/twitter.svg";
import Facebook from "assets/facebook.svg";
import Text from "ReusableComponents/Text";
import Box from "ReusableComponents/Box";

const Share = ({ small }) => {
  return (
    <Box display="flex" flexDirection="column">
      <Text
        fontSize={small ? "12px" : "16px"}
        fontWeight="bold"
        textColor="white"
        padding={small && "0 "}
      >
        Share
      </Text>
      <Box
        display="flex"
        justifyContent="space-between"
        w="100%"
        margin="0 auto"
      >
        <img
          src={Facebook}
          alt="facebook"
          height={small ? "36px" : "36px"}
          width={small ? "36px" : "36px"}
          style={{ margin: "12px 0", cursor: "pointer" }}
        />
        <img
          src={Twitter}
          height={"36px"}
          width="36px"
          alt="twitter"
          style={{ margin: "12px 0", cursor: "pointer" }}
        />
        <img
          src={Instagram}
          height={"36px"}
          width="36px"
          alt="instagram"
          style={{ margin: "12px 0", cursor: "pointer" }}
        />
        <img
          src={Youtube}
          height={"36px"}
          width="36px"
          alt="youtube"
          style={{ margin: "12px 0", cursor: "pointer" }}
        />
      </Box>
      {/* <img
        src={Copy}
        height={"36px"}
        width="36px"
        alt="copy"
        style={{ margin: "12px 0", cursor: "pointer" }}
      /> */}
    </Box>
  );
};

export default Share;
